import { formatPrice } from '@lib/utils';
import { Link } from '@components/Link';
import Typography from '@components/Typography';
import { PriceTableHeader, PriceTableWrapper, ShowMore, StyledPriceTable } from './style';

import type { Maybe } from '~/types/graphql';
import type React from 'react';

export type PriceData = {
  url: string;
  avgPriceHouseBuy?: Maybe<number>;
  avgPriceApartmentBuy?: Maybe<number>;
  name: string;
};

type Props = {
  title: string;
  tableHeadline: string;
  priceList: PriceData[];
  loadMore: () => void;
  isNextPageExist: boolean;
  singlePage: boolean;
  hideHeader?: boolean;
  withoutLink?: boolean;
};

export const PriceTableWithoutRent: React.FC<Props> = ({
  title,
  tableHeadline,
  priceList,
  loadMore,
  isNextPageExist,
  singlePage,
  hideHeader,
  withoutLink,
}: Props) => {
  if (!priceList.length) {
    return null;
  }

  return (
    <PriceTableWrapper>
      {!hideHeader && (
        <PriceTableHeader>
          <Typography type="H3" className="title">
            {title}
          </Typography>
        </PriceTableHeader>
      )}
      <StyledPriceTable>
        <thead>
          <tr>
            <th rowSpan={2} className="location-name">
              {tableHeadline}
            </th>
            <th colSpan={2} className="price-quadratmeter">
              Ø Kaufpreis (€/m²)
            </th>
          </tr>
          <tr>
            <th className="avg-price-apartment">Wohnung</th>
            <th className="avg-price-house">Haus</th>
          </tr>
        </thead>
        <tbody>
          {priceList.map((item, index) => (
            <tr key={index}>
              <td className="location-name">
                {withoutLink ? item.name : <Link route={item.url}>{item.name}</Link>}
              </td>
              <td className="avg-price-apartment">{formatPrice(item.avgPriceApartmentBuy)}</td>
              <td className="avg-price-house">{formatPrice(item.avgPriceHouseBuy)}</td>
            </tr>
          ))}
        </tbody>
      </StyledPriceTable>
      {!singlePage && (
        <ShowMore>
          <button onClick={loadMore}>{isNextPageExist ? 'Mehr' : 'Weniger'}</button>
        </ShowMore>
      )}
    </PriceTableWrapper>
  );
};
